import { get } from 'lodash/object';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { Constants } from '../global/constants';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session2.service';

import { Router, NavigationEnd } from '../../../node_modules/@angular/router';

@Component({
  selector: 'limit-warning',
  templateUrl: './limit-warning.component.html',
  styleUrls: ['./limit-warning.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LimitWarningComponent implements OnInit {

  navigationSubscription; //used to force the component to reload; This happens when you switch accounts and are already on this view

  isLoggedIn: boolean = false;
  session: any = null;
  utilizationPercentage: number = 0;
  replyLimit: number = 0;
  limitWarningPercent: number = 0;

  constructor(private authService: AuthService,
              private sessionService: SessionService,
              private router: Router,
              private constants: Constants) {

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.sessionRefresh();
      }
    });
  }

  ngOnInit() {
    this.sessionRefresh();
  }

  ngOnDestroy() {
    // avoid memory leaks here by cleaning up after ourselves. If we
    // don't then we will continue to run our initialiseInvites()
    // method on every navigationEnd event.
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private sessionRefresh() {
    if (this.authService.isLoggedIn) {
      this.limitWarningPercent = this.constants.limitWarningPercent;
      this.isLoggedIn = true;
      this.sessionService.getSession().subscribe((data: any) => {
        this.session = data;
        this.utilizationPercentage = get(this.session, 'account_utilization_percentage', 0);
        this.replyLimit = get(this.session, 'account_reply_limit', 0);
      });
    }
    else {
      this.isLoggedIn = false;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/limit-warning/limit-warning.component.ts